import { updateBasket } from 'components/basket/shared/basket';
import { GET } from 'modules/helpers/fetch';
import loadHtmlModalFunc from 'modules/modal/helpers';

import DefaultLayout from 'modules/modal/layouts';

export async function AddSingleGwp(url: string) {
    try {
        GET(url).then(() => {
            updateBasket();
        });
    } catch (error) {
        console.error(error);
    }
}

export async function initializeSelectGWPModal(url: string) {
    try {
        const giftBtnAttr = 'data-js-select-gift';
        const htmlModal = await loadHtmlModalFunc();

        const modal = htmlModal({
            layout: {
                component: (props) => <DefaultLayout customTheme={{ width: '600px' }} {...props} />
            }
        });

        modal({
            url,
            onAfterContent: ({ wrapper, close }) => {
                wrapper.querySelectorAll(`[${giftBtnAttr}]`)?.forEach((btn) =>
                    btn?.addEventListener('click', (e) => {
                        const selectGiftUrl = (e.currentTarget as HTMLButtonElement)?.getAttribute(giftBtnAttr);
                        if (selectGiftUrl) {
                            GET(selectGiftUrl).then(() => {
                                close();
                                updateBasket();
                            });
                        }
                    })
                );
            }
        });
    } catch (error) {
        console.error(error);
    }
}
